import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcMulticloud = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M4.916 13a5.001 5.001 0 0 1 4.9-2.99 6.256 6.256 0 0 1 3.65-2.57A4.5 4.5 0 0 0 4.5 8h-1a2.5 2.5 0 0 0 0 5h1.416Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M6.5 15a3 3 0 0 1 4.407-2.65 4.252 4.252 0 0 1 8.315.657A3.5 3.5 0 0 1 19 20H6.5a2.5 2.5 0 0 1 0-5Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcMulticloud");

export { IcMulticloud };
//# sourceMappingURL=ic-multicloud.js.map
